/**
 * Stash paywall / hub CTA context before MSAL loginRedirect.
 * authInsightsRuntime attaches it to auth_started so GA4 can attribute registration source.
 */
const KEY = 'aiq_auth_cta';
const MAX_AGE_MS = 30 * 60 * 1000;

function normalizeCtaContext(input = {}) {
    const surface = String(input.surface || '').trim().slice(0, 64);
    const reason = String(input.reason || '').trim().slice(0, 64);
    const cta = String(input.cta || '').trim().slice(0, 32);
    const out = {};
    if (surface) out.surface = surface;
    if (reason) out.reason = reason;
    if (cta) out.cta = cta;
    return out;
}

function stashAuthCtaContext(input = {}, storage = typeof sessionStorage !== 'undefined' ? sessionStorage : null) {
    if (!storage) return;
    const ctx = normalizeCtaContext(input);
    if (!Object.keys(ctx).length) return;
    try {
        storage.setItem(KEY, JSON.stringify({ ...ctx, at: Date.now() }));
    } catch {
        /* Storage may be blocked. */
    }
}

function consumeAuthCtaContext(storage = typeof sessionStorage !== 'undefined' ? sessionStorage : null) {
    if (!storage) return {};
    try {
        const raw = storage.getItem(KEY);
        storage.removeItem(KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        if (!parsed || !Number.isFinite(parsed.at) || Date.now() - parsed.at > MAX_AGE_MS) return {};
        return normalizeCtaContext(parsed);
    } catch {
        return {};
    }
}

module.exports = {
    AUTH_CTA_KEY: KEY,
    stashAuthCtaContext,
    consumeAuthCtaContext,
    normalizeCtaContext,
};
